<div class="additional-info">
  <h5>Dica!</h5>
  <p>{{ tipText }}</p>
  <hr />
  <button (click)="closeModal()">Fechar</button>
</div>
